import { filterDropdown } from './filters/filter-dropdown';
import { filterActions } from './filters/filter-actions';
import { clearFilters } from './filters/clear-filters';
import { inputTextFilter } from './filters/input-text-filter';
import { selectEntries } from './table/select-entries';
import { selectEntriesActions } from './table/select-entries-actions';
import { getEntriesData } from './table/get-entries-data';
import { dashboardHeader } from './header/header.js';
import { dashboardMenu } from './menu/menu.js';

/**
 * All Dashboard functionnality.
 */
function dashboard() {
	if ( document.querySelector( '.o__dashboard' ) ) {
        dashboardHeader();
        filterDropdown();
        filterActions();
        clearFilters();
        inputTextFilter();
        selectEntries();
        selectEntriesActions();
        getEntriesData();
        dashboardMenu();
	}
}

export default dashboard;